import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnvironmentImpactAssessmentsV2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 56,
	viewBox: "0 0 43 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1353_15350)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4 55.0098C10.4 53.1398 11.83 53.1398 11.83 51.2598C11.83 49.3898 10.4 49.3898 10.4 47.5098C10.4 45.6298 11.83 45.6398 11.83 43.7698C11.83 41.8998 10.4 41.8998 10.4 40.0298C10.4 38.1598 11.83 38.1598 11.83 36.2898L11.88 35.7498C11.88 35.0798 11.3 34.4898 10.25 34.2998C8.51999 33.9698 6.93999 34.7598 6.93999 35.7598L6.91999 36.2898C6.91999 38.1598 5.48999 38.1598 5.48999 40.0298C5.48999 41.8998 6.91999 41.8998 6.91999 43.7698C6.91999 45.6398 5.48999 45.6398 5.48999 47.5098C5.48999 49.3798 6.91999 49.3798 6.91999 51.2598C6.91999 53.1398 5.48999 53.1298 5.48999 55.0098H10.39H10.4Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.54 55.0098C14.54 52.0398 16.18 52.0398 16.18 49.0598C16.18 46.0898 14.54 46.0898 14.54 43.1098C14.54 40.1298 16.18 40.1398 16.18 37.1698C16.18 34.1998 14.54 34.1998 14.54 31.2298C14.54 28.2598 16.18 28.2598 16.18 25.2898L16.04 24.4498C16.04 23.0998 17.32 22.0098 18.9 22.0098C20.48 22.0098 21.76 23.0998 21.76 24.4498V25.2898C21.76 28.2598 20.12 28.2598 20.12 31.2298C20.12 34.1998 21.76 34.1998 21.76 37.1698C21.76 40.1398 20.12 40.1398 20.12 43.1098C20.12 46.0798 21.76 46.0798 21.76 49.0598C21.76 52.0298 20.12 52.0298 20.12 55.0098H14.53H14.54Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.5101 53.8501C29.5101 51.9801 30.9401 51.9801 30.9401 50.1001C30.9401 48.2301 29.5101 48.2301 29.5101 46.3501C29.5101 44.4701 30.9401 44.4801 30.9401 42.6101C30.9401 40.7401 29.5101 40.7401 29.5101 38.8701C29.5101 37.0001 30.9401 37.0001 30.9401 35.1301L30.9901 34.5901C30.9901 33.9201 30.4101 33.3301 29.3601 33.1401C27.6301 32.8101 26.0501 33.6001 26.0501 34.6001L26.0301 35.1301C26.0301 37.0001 24.6001 37.0001 24.6001 38.8701C24.6001 40.7401 26.0301 40.7401 26.0301 42.6101C26.0301 44.4801 24.6001 44.4801 24.6001 46.3501C24.6001 48.2201 26.0301 48.2201 26.0301 50.1001C26.0301 51.9801 24.6001 51.9701 24.6001 53.8501H29.5001H29.5101Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0601 53.8698C12.0601 51.1098 13.5401 51.1098 13.5401 48.3598C13.5401 45.6098 12.0601 45.5998 12.0601 42.8498C12.0601 40.0998 13.5401 40.0998 13.5401 37.3398C13.5401 34.5798 12.0601 34.5798 12.0601 31.8298C12.0601 29.0798 13.5401 29.0798 13.5401 26.3198L13.4101 25.5398C13.4101 24.2898 14.5701 23.2798 16.0001 23.2798C17.4301 23.2798 18.5901 24.2898 18.5901 25.5398V26.3198C18.5901 29.0698 17.1101 29.0698 17.1101 31.8298C17.1101 34.5898 18.5901 34.5898 18.5901 37.3398C18.5901 40.0898 17.1101 40.0898 17.1101 42.8498C17.1101 45.6098 18.5901 45.6098 18.5901 48.3598C18.5901 51.1098 17.1101 51.1198 17.1101 53.8698",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.22 53.4198C22.22 51.5998 23.56 51.5998 23.56 49.7898C23.56 47.9798 22.22 47.9698 22.22 46.1598C22.22 44.3498 23.56 44.3398 23.56 42.5298C23.56 40.7198 22.22 40.7098 22.22 38.8998C22.22 37.0898 23.56 37.0898 23.56 35.2698L23.58 34.7598C23.58 33.7798 25.06 33.0198 26.67 33.3398C27.65 33.5298 28.19 34.0998 28.19 34.7498L28.14 35.2698C28.14 37.0798 26.8 37.0798 26.8 38.8998C26.8 40.7198 28.14 40.7198 28.14 42.5298C28.14 44.3398 26.8 44.3498 26.8 46.1598C26.8 47.9698 28.14 47.9798 28.14 49.7898C28.14 51.5998 26.8 51.6098 26.8 53.4198",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1 54H42",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.05005 54.6498C3.05005 52.8298 4.39005 52.8298 4.39005 51.0198C4.39005 49.2098 3.05005 49.1998 3.05005 47.3898C3.05005 45.5798 4.39005 45.5698 4.39005 43.7598C4.39005 41.9498 3.05005 41.9398 3.05005 40.1298C3.05005 38.3198 4.39005 38.3198 4.39005 36.4998L4.41005 35.9898C4.41005 35.0098 5.89005 34.2498 7.50005 34.5698C8.48005 34.7598 9.02005 35.3298 9.02005 35.9798L8.97005 36.4998C8.97005 38.3098 7.63005 38.3098 7.63005 40.1298C7.63005 41.9498 8.97005 41.9498 8.97005 43.7598C8.97005 45.5698 7.63005 45.5798 7.63005 47.3898C7.63005 49.1998 8.97005 49.2098 8.97005 51.0198C8.97005 52.8298 7.63005 52.8398 7.63005 54.6498",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.54 8.1001H25.54V11.1001H36.54V8.1001Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.54 15.1001H25.54V18.1001H36.54V15.1001Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.5 22H31V25H36.5V22Z",
				fill: "#F7DD97"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1 32V1H42V55.01V53",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 9H33",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 16H33",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25 23L33 23",
				stroke: "#256F94",
				strokeWidth: 2,
				strokeMiterlimit: 10
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1353_15350",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 43,
			height: 55.01,
			fill: "white"
		})
	}) })]
});
export default SvgEnvironmentImpactAssessmentsV2;
